var heading_default = {
  "fontElementMap": "yoMPN",
  "elementSpacing": "_8NRzP",
  "headerOne": "-ib3k _8NRzP",
  "headerTwo": "Zxn-9 _8NRzP",
  "headerThree": "_8hX9s _8NRzP",
  "headerFour": "NbbV- _8NRzP",
  "headerFive": "mlTZU _8NRzP",
  "headerSix": "Wdvpn _8NRzP",
  "child": "p4Cnw"
};
export {
  heading_default as default
};
//# sourceMappingURL=heading-scss.js.map
